/**
 * Created by hzy on 2019/7/17.
 */
import React, {Component} from 'react';
import PropTypes, {oneOfType} from 'prop-types';
import {Button} from 'antd-mobile';
import {registerRoutes} from 'mutants-microfx';
import {TopNavPage} from 'mutants-mobile-navigator';
import Filter from './index';
import './style.less';
import {Icon } from 'antd-mobile';


@TopNavPage
export default class FilterViewPage extends Component {
  state = {}
  static contextTypes = {
    pop:PropTypes.func,
    popAndReturn:PropTypes.func,
  }

  navTitle() {
    return '筛选';
  }
  resetData = () => {

  }
  onOk = (data) => {
    console.log('submit-data: ', data);

    //返回带入数据
    this.popAndReturn('ok',{'data':data});
  }

  render() {
    const {location: {state}} = this.props;
    const dataSource = state.config;  // 数据
    const id = state.key; // 储于localstorage的标识id

    return <Filter
      dataSource={dataSource}
      onOk={this.onOk}
      resetData={this.resetData}
      id={`${id}Cache`}
    />;
  }
}

registerRoutes([
  {
    path: '/filter',
    component: FilterViewPage
  }
]);
